import React from 'react';
import { useNavigate } from 'react-router';

import FeedbackCard from '../../../../FeedbackCard/FeedbackCard';

export const classes = {
	feedbackCard: {
		position: 'relative',
		marginBottom: (theme) => theme.spacing(2),
		overflow: 'visible',
		'&:focus': {
			outline: 'none',
		},
		'&.MuiPaper-outlined': {
			border: '1px solid rgba(0, 0, 0, 0.12)',
		},
	},
	feedbackContent: {
		whiteSpace: 'pre-line',
		wordBreak: 'break-word',
	},
	feedbackTitle: {
		fontWeight: 600,
		fontSize: '1.2rem',
		wordBreak: 'break-word',
	},
	feedbackCardContentRoot: {
		paddingTop: 0,
	},
	feedbackInfoLabel: {
		fontWeight: 600,
	},
	feedbackViewDetails: {
		justifyContent: 'flex-end',
	},
};

const Feedback = ({ feedback }) => {
	const navigate = useNavigate();
	const onViewDetailsClick = () => {
		const search = new URLSearchParams(location.search);
		navigate(
			`/proxy/feedback/dashboard/workflow/feedback/${feedback.feedbackRequestId}?${search.toString()}`,
		);
	};

	const isDisabled = () => {
		if (feedback.feedbackRequestStatus === 'CANCELLED') {
			return true;
		}
		if (feedback.feedbackState === 'SUBMITTED') {
			// Disable if hideSummary is true
			return feedback.hideSummary === true;
		}
		return feedback.permissions !== 'rw';
	};

	const hideFeedback = feedback.feedbackState === 'SUBMITTED' && feedback.hideSummary === true;
	return (
		<FeedbackCard
			view="feedbackTabView"
			feedbackInfo={{ ...feedback, disabled: isDisabled() }}
			handleOnClick={onViewDetailsClick}
			hideFeedback={hideFeedback}
		/>
	);
};

export default Feedback;
